import { render } from "./AddressInput.vue?vue&type=template&id=38181e05"
import script from "./AddressInput.vue?vue&type=script&lang=js"
export * from "./AddressInput.vue?vue&type=script&lang=js"

import "./AddressInput.vue?vue&type=style&index=0&id=38181e05&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__